import { Col, Form, Row } from "react-bootstrap";

const SixthStep = ({sixthStep, updateMultipleValues}) => {

    const handleChangeRadio = (e) => {
        const values = {...sixthStep};
        values[e.target.id] = parseInt(e.target.value);
        updateMultipleValues({sixthStep: values});
    }
    return (
      <>
        <div className="second-step-main-container rounded-3 mx-auto d-flex flex-column  position-relative"  onChange={(e) => handleChangeRadio(e)}>
        
            <h1 className="register-text" style={{fontSize: 40, marginBottom: 25, textAlign: "center"}}>Satisfaction with assessment methods and outcomes</h1>
            {/* <div className="d-flex  align-items-end"> */}
            <Row>
                <Col xl={7}>
                </Col>
                <Col xl={1}><div className="form-label" >Strongly disagree</div>
                </Col>
                <Col xl={1}><div className="form-label" >Disagree</div>
                </Col>
                <Col xl={1}><div className="form-label" >Neutral</div>
                </Col>
                <Col xl={1}><div className="form-label" >Agree</div>
                </Col>
                <Col xl={1}><div className="form-label" >Strongly agree</div>
                </Col>
            </Row>
            <Form>
                <Form.Group>
                    <Row style={{marginTop: 20}}>
                    
                        <Col xl={7}><div className="form-label" >Details of the assessment(s) were communicated to me before the start of the course *</div>
                        </Col>
                        
                        <Col xl={1}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`methods_details_communication`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_details_communication === 1}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`methods_details_communication`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_details_communication === 2}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`methods_details_communication`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_details_communication === 3}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`methods_details_communication`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_details_communication === 4}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`methods_details_communication`}
                                    name="group1"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_details_communication === 5}
                                />
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row>
                    
                        <Col xl={7}><div className="form-label" >The actual assessment(s) were like what was communicated beforehand *</div>
                        </Col>
                        
                        <Col xl={1}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`methods_communication_correspondence`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_communication_correspondence === 1}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`methods_communication_correspondence`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_communication_correspondence === 2}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`methods_communication_correspondence`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_communication_correspondence === 3}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`methods_communication_correspondence`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_communication_correspondence === 4}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`methods_communication_correspondence`}
                                    name="group2"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_communication_correspondence === 5}
                                />
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row>
                    
                        <Col xl={7}><div className="form-label" >The assessment(s) represented the subjects discussed in the course *</div>
                        </Col>
                        
                        <Col xl={1}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`methods_subject_consistency`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_subject_consistency === 1}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`methods_subject_consistency`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_subject_consistency === 2}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`methods_subject_consistency`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_subject_consistency === 3}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`methods_subject_consistency`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_subject_consistency === 4}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`methods_subject_consistency`}
                                    name="group3"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_subject_consistency === 5}
                                />
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row>
                    
                        <Col xl={7}><div className="form-label" >The assessment(s) was/were applied fairly with attention to cultural differences of the students *</div>
                        </Col>
                        
                        <Col xl={1}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`methods_cultural_attention`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_cultural_attention === 1}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`methods_cultural_attention`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_cultural_attention === 2}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`methods_cultural_attention`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_cultural_attention === 3}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`methods_cultural_attention`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_cultural_attention === 4}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`methods_cultural_attention`}
                                    name="group4"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_cultural_attention === 5}
                                />
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
            <hr style={{marginTop: 20, marginBottom: 20}}/>
            <Form>
                <Form.Group>
                    <Row>
                    
                        <Col xl={7}><div className="form-label" >I am satisfied with what I’ve learned during the course *</div>
                        </Col>
                        
                        <Col xl={1}>
                                <Form.Check
                                    value={1}
                                    type={"radio"}
                                    id={`methods_learning_satisfaction`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_learning_satisfaction === 1}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={2}
                                    type={"radio"}
                                    id={`methods_learning_satisfaction`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_learning_satisfaction === 2}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={3}
                                    type={"radio"}
                                    id={`methods_learning_satisfaction`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_learning_satisfaction === 3}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={4}
                                    type={"radio"}
                                    id={`methods_learning_satisfaction`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_learning_satisfaction === 4}
                                />
                        </Col>
                        <Col xl={1}>
                                <Form.Check
                                    value={5}
                                    type={"radio"}
                                    id={`methods_learning_satisfaction`}
                                    name="group5"
                                    style={{fontSize: 16}}
                                    checked={sixthStep?.methods_learning_satisfaction === 5}
                                />
                        </Col>
                    
                    </Row>
                </Form.Group>
            </Form>
      </div>
      </>
    );
  };
  
  export default SixthStep;
  